import VueClipboard from 'vue-clipboard2'

export default {
  install(Vue) {
    Vue.use(VueClipboard)
  },
}
